import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalexpercommentbacktbn from './Modalexpercommentbacktbn';
import { URL,api } from '../../api';
import Modalexpercommentbackexrob2 from './Modalexpercommentbackexrob2';


export default class Commentbnlistbackexcheck extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   expert_id:'',
   commentbn:[],
   url:'https://mua.kpru.ac.th/FrontEnd_Conferencekpru/',
   
}


//this.handleSubmit = this.handleSubmit.bind(this);

this.toggle = this.toggle.bind(this);
this.list = this.list.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()
;  this.props.selectex();
}


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_send:this.props.id_send,
                       expert_id:this.props.expert_id,
         })
      setTimeout(() => {
       
        api.get('registercon/selectArticleforexpertbnchecklist/'+this.props.expert_id+'/'+this.props.id_send, )
        .then(res => {
          console.log(res);
       
          this.setState({ commentbn: res.data})
        }) 

      }, 0);

  }

  list() {
 
      setTimeout(() => {
        api.get('registercon/selectArticleforexpertbnchecklist/'+this.props.expert_id+'/'+this.props.id_send, )
        .then(res => {
          console.log(res);
          this.setState({ commentbn: res.data})
        }) 

      }, 0);

  }



    render() {
        

        return (
            <>
           <MDBTable small>
      <MDBTableHead color="blue-grey lighten-3" textWhite>
        <tr>
          <th>ลำดับ</th>
          <th>ไฟล์บทความปรับแก้</th>
          <th>ไฟล์ข้อเสนอแนะจากผู้ทรงคุณวุฒิ</th>
          <th>วันที่</th>
          <th>ไฟล์ข้อเสนอแนะ</th>
          <th>วันที่ส่งกลับ</th>
          <th>สถานะ ผ่าน/ปรับแก้ไข</th>
          <th>การส่งกลับ</th>
          
        </tr>
      </MDBTableHead>
      <MDBTableBody>
                      {this.state.commentbn.map((commentbn,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        {/* <td>{commentbn.fileword}</td> */}
                        <td>{commentbn.fileclosenameword !== null ? <>
                            <a href={`${this.state.url+commentbn.fileclosenameword}`}  target="_blank"><p className="blue-text"><MDBIcon far icon="file-word" /> ไฟล์บทความ .word</p> </a>
                            <a href={`${this.state.url+commentbn.fileclosenamepdf}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-word" /> ไฟล์บทความ .pdf</p> </a>
                           </>:<><MDBIcon far icon="hourglass" /></>}</td>
                           <td>{commentbn.filewordcomment_expertcheck !== null ? <>
                            <a href={`${this.state.url+commentbn.filewordcomment_expertcheck}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-word" /> ไฟล์ข้อเสนอแนะ .pdf</p> </a>
                          
                           </>:<><MDBIcon far icon="hourglass" /></>}</td>

                        <td>{commentbn.date_sentexpert}</td>

                        {/* <td>{commentbn.filewordcomment_bn !== null ? <>{commentbn.filewordcomment_bn}</>:<><MDBIcon far icon="hourglass" /></>}</td> */}
                        <td>{commentbn.filewordcomment_experten != undefined  ? <>
                            <a href={`${this.state.url+commentbn.filewordcomment_experten}`} target="_blank"><p className="green-text"><MDBIcon far icon="file-word" /> ไฟล์ข้อเสนอแนะ .word</p> </a>
                            
                           </>:<>
                           {commentbn.statuscomment_expert==='1'?<>-</>:<> <MDBIcon far icon="hourglass" /></>}
                          
                           </>}</td>

                        <td>{commentbn.date_senbackexpert != undefined || commentbn.date_senbackexpert != null ?<>{commentbn.date_senbackexpert}</>:<><MDBIcon far icon="hourglass" /></>}</td>

                        <td>{commentbn.statuscomment_expert==='1'?<>ผ่าน</>:<>
                               {commentbn.statuscomment_expert==='2'?<>ปรับแก้ไข</>:<><MDBIcon far icon="hourglass" /> รอพิจารณา</>}
                            </>}
                        </td>
                        <td>{commentbn.filewordcomment_bn !== undefined ?<>
                        ยังไม่ส่งกลับแล้ว
                        </>:<>
                          {commentbn.statuscomment_expert ==='1' || commentbn.statuscomment_expert ==='2'  ?<>แจ้งกลับแล้ว</>:<>

                               <Modalexpercommentbackexrob2 id_send={commentbn.id_sendarticle} id_comment={commentbn.id_commentex} id_bn={commentbn.id_experten} list={this.list}  />
                          </>}
                        
                        </>}
                        {}
                            
                            </td>
                        </tr>
                      )}
       
      </MDBTableBody>
    </MDBTable>
           
          </>
          
        )
    }
}


